import { fetchSnippet, Snippet, SnippetType } from '@creditsights/api-ui-web';
import { useQuery, UseQueryResult } from 'react-query';
import { SNIPPETS_CACHE_KEY } from '../../Constants';

export default (type: SnippetType, id: string): UseQueryResult<Snippet, Error> => {
  return useQuery<Snippet, Error>([SNIPPETS_CACHE_KEY, type, id], async () => fetchSnippet(type, id));
};
